<template>
	<div id="login-container" @keyup.enter="login">
		<img src="@/../static/bo-icone.svg" id="logo"/>

		<div id="login">
			<span class="header">
				<img :src="logoPath" id="img-title"/>
			</span>
			<span class="field" :class="{invalid:form.$errors.username}">
				<label for="username">{{$t('user')}}:</label>
				<label for="username" id="errorMessage" v-if="form.$errors.showMessage">{{t(form.$errors.message)}}</label><br>
				<input 
					id="username" required 
					type="email" v-model="form.username"
					@blur="setFieldErrorsOnForm('username', isValidEmail)"
					placeholder="usuario@email.com"
				/>
			</span>
			<span class="field" :class="{invalid:form.$errors.password}">
				<label for="password">{{$t('password')}}:</label><br>
				<input 
					id="password" required 
					type="password" v-model="form.password"
					@blur="setFieldErrorsOnForm('password', isValidPassword)"
				/>
			</span>
			<span class="button-container">
				<input
					type="submit"
					id="submit"
					@click="login"
					:value="$t('enter')"
					class="button"
				/>
			</span>
			<div class="languages">
				<v-select
					class="languages-select"
					:multiple="false"
					:options="view.langs"
					:getOptionLabel="lang => `${lang.description}`"
					:clearable="false" 
					v-model="view.selectedLanguage"
					@input="onChangeLanguage"
				></v-select>
			</div>
		</div>
	</div>
</template>

<script>
import LoginController from "../controllers/LoginController";
import vSelect from "vue-select";
import { changeLanguage } from 'i18next';
import { t } from 'i18next';
export default {
	name: "Login",
	components: {
        "v-select": vSelect,
    },
	data() {
		return {
			/**
			 * View to template datas
			 */
			view: {
				title: "Login",
				langs: [
					{
						name: "pt-BR",
						description: "Português"
					},
					{
						name: "en-US",
						description: "Inglês"
					},
					{
						name: "es-CL",
						description: "Espanhol"
					}
				],
				selectedLanguage: {
					name: "pt-BR",
					description: "Português"
				}
			},

			/**
			 * Login form data
			 */
			form: {
				username: "",
				password: "",
				$errors:{
					username:false,
					password:false,
					message:'invalid_user_or_password'
				}
			},
			
			isLogged: null
		};
	},

	created(){
		LoginController.$router = this.$router;
		LoginController.$modal = this.$modal;
		this.testLogin();
	},

	computed:{
		/**
		 * Check is email is filled.
		 * 
		 * @returns {Boolean}
		 */
		isValidEmail:function(){
			return this.form.username;
		},

		/**
		 * Check is email is filled.
		 * 
		 * @returns {Boolean}
		 */
		isValidPassword:function(){
			return this.form.password;
		},
		logoPath() {
	   	if (this.view.selectedLanguage.name === 'es-CL') {
	      	return "@/../static/bo-logotipo-es.png";
	      } else if(this.view.selectedLanguage.name === 'en-US') {
	        return "@/../static/bo-logotipo-en.png";
	      }else{
	      	return "@/../static/bo-logotipo-pt.png";
	      }
	   },			
	   
	},
	
	mounted() {
		document.title = `${this.view.title} - Cardápio Inteligente`;
		let lang = localStorage.getItem('lang') || 'pt-BR';
		this.view.selectedLanguage = this.view.langs.find( lng => lng.name === lang);
	},

	methods: {
		/**
		 * Attempt to login with form data.
		 */
		login: function(){
			if(this.isValidEmail && this.isValidPassword){
				LoginController.doLogin(this.form.username, this.form.password).catch(function(){
					this.form.$errors.showMessage = true;
					this.$forceUpdate();
				}.bind(this));
			} else {
				this.setFieldErrorsOnForm('username', this.isValidEmail);
				this.setFieldErrorsOnForm('password', this.isValidPassword);
			}
		},

		/**
		 * Set validate errors in form data.
		 */
		setFieldErrorsOnForm(fieldName, isValid){
			let errors = this.form.$errors;
			errors[fieldName] = !isValid;
			errors.showMessage = errors.username || errors.password;
		},

		testLogin(){
			if(LoginController.hasSystemToken()){
				LoginController.isLogged().then(() => {
					this.logged = true;
					this.$router.push("restrictions");
				}).catch(function(r){
					
				});
			}
		},

		onChangeLanguage(){
			let language = this.view.selectedLanguage.name;
			changeLanguage(language);
			localStorage.setItem('lang', language);
			this.view.selectedLanguage = this.view.langs.find(lang => lang.name === language);
		},
		
		t(value){
			return t(value);
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
#login-container{
	#logo {
		height: 80px;
		width: 80px;
		display: inline-block;
		position: fixed;
		z-index: 0;
		left: 80px;
		bottom: 120px;
		transform: scale(10);
		filter: drop-shadow(-1px 1px 2px black);
	}

	height: 100%;
	width: 100%;
	background-color: #212146;

	#login{
		width: 40vw;
		display: table;
		margin: auto;
		top: 50%;
		left: 50%;
		bottom: 0;
		right: 0;
		position: fixed;
		padding: 50px;
		background-color: rgba(0, 0, 0, .4);
		border-radius:10px;
		transform: translate(-50%, -50%);
		.header {
			display: inherit;
			margin: 0 auto;
			width: auto;
			height: auto;
			
			

			#img-title{
				width: 220px;
				display: inline-block;
				vertical-align: middle;
				filter: drop-shadow(-1px 4px 2px black);
			}
		}

		.field{
			display: inline-block;
			width: 100%;
			width: calc(100% - 24px);
			margin: 10px;
			text-align: left;
			font-weight: 500;
			color: white;
			text-shadow: -1px 1px 3px black;

			input{
				font-size: 1rem;
				padding: 11px 12px;
				border: 1px solid #BDBDBD;
				box-sizing: border-box;
				border-radius: 4px;
				width: 100%;
			}
		}

		.invalid{
			color: #ff0045;
		}

		.button{
			width: 100%;
			width: calc(100% - 24px);
			margin: 10px;

			&:hover{
				background-color: #8e0e28;
			}
		}

		#errorMessage{
			color: #ff0045;
			position:absolute;
			right: 40px;
		}
	}

	.languages {
		display: flex;
		justify-content: flex-end;
		margin: 15px;

		.languages-select {
			min-width: 40%;
		}
	}
	
}
</style>
